import { setStorage, getStorage, clearStorage } from "@/utils/localStorageLib";
import { apiPost } from "@/api/api";

const pagesKey = "etms_permissions";

export function setPermission(permission) {
  clearStorage(pagesKey);
  setStorage(pagesKey, permission);
}

export function clearPermission() {
  console.log("clear page key...")
  clearStorage(pagesKey);
}

async function refreshPermission() {
  return new Promise((resolve, reject) => {
    apiPost("/user/getLoginPermission", {})
      .then(response => {
        const { resultData } = response;
        setPermission(resultData);
        resolve(resultData);
      })
      .catch(error => {
        console.log(error);
        reject(error);
      });
  });
}

export async function getPermission() {
  var obj = getStorage(pagesKey);
  if (!obj) {
    obj = await refreshPermission();
  }
  return obj;
}

/*
 检验叶子page 
 leafPages:[{id:0,label:'',name:''}]
*/
export async function checkLeafPage(leafPages) {
  var myPermission = await getPermission();
  var newPages = [];
  leafPages.forEach(item => {
    if (myPermission.page.indexOf(item.id) != -1) {
      newPages.push(item);
    }
  });
  return newPages;
}

/*
校验page权限
*/
export async function checkPage(myPages) {
  var myPermission = await getPermission();
  for (var key in myPages) {
    if (myPermission.page.indexOf(parseInt(key)) != -1) {
      myPages[key] = true;
    }
  }
  return myPages;
}

/*
校验page权限（机构）
*/
export async function checkTenantPage(myPages) {
  var myPermission = await getPermission();
  for (var key in myPages) {
    if (myPermission.tenantPage.indexOf(parseInt(key)) != -1) {
      myPages[key] = true;
    }
  }
  return myPages;
}

/*
检验操作权限 
*/
export async function checkAction(myActions) {
  var myPermission = await getPermission();
  for (var key in myActions) {
    if (myPermission.action.indexOf(parseInt(key)) != -1) {
      myActions[key] = true;
    }
  }
  return myActions;
}

/*
校验首页快捷入口菜单
        {
          name: "学员档案",
          routerName: "studentRecord",
          img: defaultImg,
          type: 0,
          Id: 2,
        },
*/
export async function checkHomeQuickMenu(allMenus) {
  var myPermission = await getPermission();
  var newMenus = [];
  allMenus.forEach(item => {
    if (item.id === 0) {
      newMenus.push(item);
    } else {
      if (item.type === 0) {
        if (myPermission.page.indexOf(item.id) != -1) {
          newMenus.push(item);
        }
      } else {
        if (myPermission.action.indexOf(item.id) != -1) {
          newMenus.push(item);
        }
      }
    }
  });
  return newMenus;
}



// WEBPACK FOOTER //
// ./src/utils/permissionLib.js